import React from 'react';
import { useNavigate } from 'react-router-dom';
import Gallery from '../components/Gallery';

const Realisations = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white">
      {/* Header avec retour */}
      <div className="bg-gradient-to-r from-orange-500 to-yellow-400 text-white py-8 shadow-lg">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <button
            onClick={() => navigate('/')}
            className="flex items-center text-white hover:text-white/80 transition-colors mb-4 font-semibold"
          >
            <svg className="w-6 h-6 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"/>
            </svg>
            Retour à l'accueil
          </button>
          
          <div className="flex items-center space-x-4">
            <div className="w-16 h-16 bg-white/20 rounded-2xl flex items-center justify-center">
              <span className="text-4xl">📸</span>
            </div>
            <div>
              <h1 className="text-4xl lg:text-5xl font-bold">Toutes nos Réalisations</h1>
              <p className="text-white/90 text-lg mt-2">Découvrez l'ensemble de nos interventions</p>
            </div>
          </div>
        </div>
      </div>

      {/* Galerie complète */}
      <Gallery />

      {/* CTA en bas */}
      <div className="bg-gradient-to-br from-blue-900 to-blue-800 text-white py-16">
        <div className="max-w-4xl mx-auto text-center px-6">
          <h2 className="text-3xl lg:text-4xl font-bold mb-4">
            Vous avez un projet similaire ?
          </h2>
          <p className="text-xl text-white/90 mb-8">
            Contactez-nous pour un devis gratuit et personnalisé
          </p>
          <button
            onClick={() => navigate('/#contact')}
            className="bg-white text-blue-900 px-10 py-4 rounded-full font-bold text-lg hover:bg-gray-100 transition-colors inline-flex items-center space-x-2"
          >
            <span>Demander un devis</span>
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7l5 5m0 0l-5 5m5-5H6"/>
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Realisations;